// extracted by mini-css-extract-plugin
export default {"container":"Blog_container__-iofA","reviews":"Blog_reviews__A9-EW","users":"Blog_users__SsXFm"};